<template>
  <div class="wrapBox">
    <div class="top">
      <el-button type="primary" @click.native="goback">返回</el-button>
    </div>
    <div class="son-wrap">
      <el-container style="flex-direction: column">
        <div class="son-box">
          <el-form
            size="medium"
            :inline="true"
            :model="queryForm"
            ref="queryForm"
            @submit.native.prevent
          >
            <div>
              <el-form-item>
                <date-picker
                  :startTime="queryForm.startTime"
                  :endTime="queryForm.endTime"
                  @changeStart="changeStart"
                  @changeEnd="changeEnd"
                >
                </date-picker>
              </el-form-item>
              <el-button
                v-if="hasPerm('base:station:list')"
                type="primary"
                @click="query"
                >查询</el-button
              >
              <el-button @click="reset">取消</el-button>
              <el-button
                v-if="hasPerm('base:station:import')"
                type="primary"
                class="btn-width"
                @click="exportFile"
                >导出</el-button
              >
            </div>
            <el-row class="expenseItem">
              <el-col :span="5">
                <el-col :span="11">费用总支出（元）：</el-col>
                <el-col :span="13">{{ outlayCount.countPrice }}</el-col>
              </el-col>
              <el-col :span="5">
                <el-col :span="14">维保总支出（自费/元）：</el-col>
                <el-col :span="10">{{ outlayCount.ownPrice }}</el-col>
              </el-col>
              <el-col :span="5">
                <el-col :span="14">维保总支出（免费/元）：</el-col>
                <el-col :span="10">{{ outlayCount.freePrice }}</el-col>
              </el-col>
              <el-col :span="5">
                <el-col :span="11">加油总支出（元）：</el-col>
                <el-col :span="13">{{ outlayCount.oilPrice }}</el-col>
              </el-col>
              <el-col :span="4">
                <el-col :span="13">其他总支出（元）：</el-col>
                <el-col :span="11">{{ outlayCount.otherPrice }}</el-col>
              </el-col>
            </el-row>
          </el-form>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="维保支出" name="maintain">
              <el-table
                ref="multipleTable"
                :data="repairList"
                style="width: 100%"
                max-height="540"
                size="mini"
                row-key="id"
                border
                default-expand-all
                :tree-props="{ children: 'children' }"
              >
                <el-table-column
                  prop="plateNum"
                  label="车牌号"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="outlayName"
                  label="维修站名称"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="payTime"
                  label="受理时间"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="completeTime"
                  label="完工时间"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="acceptMileage"
                  label="受理里程（公里）"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="payPrice"
                  label="自费金额（元）"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="freePrice"
                  label="免费金额（元）"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="维保结算单"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <img
                      class="expenseImg"
                      v-if="scope.row.voucherUrl"
                      @click="checkImg(scope.row.voucherUrl)"
                      :src="scope.row.voucherUrl"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="加油支出" name="oil">
              <el-table
                ref="multipleTable"
                :data="oilList"
                style="width: 100%"
                max-height="540"
                size="mini"
                row-key="id"
                border
                default-expand-all
                :tree-props="{ children: 'children' }"
              >
                <el-table-column
                  prop="plateNum"
                  label="车牌号"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="outlayName"
                  label="加油站名称"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="payTime"
                  label="交易时间"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="goodsName"
                  label="油品"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="unitPrice"
                  label="单价（元/升）"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="amount"
                  label="数量（升）"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="payPrice"
                  label="金额（元）"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="payTypeName"
                  label="付款方式"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="加油票据"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <img
                      class="expenseImg"
                      v-if="scope.row.voucherUrl"
                      @click="checkImg(scope.row.voucherUrl)"
                      :src="scope.row.voucherUrl"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="其他支出" name="other">
              <el-table
                ref="multipleTable"
                :data="otherList"
                style="width: 100%"
                max-height="540"
                size="mini"
                row-key="id"
                border
                default-expand-all
                :tree-props="{ children: 'children' }"
              >
                <el-table-column
                  prop="plateNum"
                  label="车牌号"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="outlayType"
                  label="支出名称"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{ matchOtherPayName(scope.row.outlayType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="payTime"
                  label="交易时间"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="payPrice"
                  label="金额（元）"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="票据"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <img
                      class="expenseImg"
                      v-if="scope.row.voucherUrl"
                      @click="checkImg(scope.row.voucherUrl)"
                      :src="scope.row.voucherUrl"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-container>
    </div>
    <el-dialog
      title="票据"
      :visible.sync="deiverVisible"
      width="480px"
      class="mini-dialog deiverBody"
    >
      <div class="imgWrap" style="padding-bottom: 10px">
        <el-image
          style="width: 440px; height: 280px"
          :src="imgUrl"
          :preview-src-list="imgUrlList"
        >
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue"
export default {
  name: "ExpenseRecord",
  components: {
    DatePicker,
  },
  props: {
    vinList: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      deiverVisible: false,
      imgUrl: "",
      imgUrlList: [],
      queryForm: {
        startTime: "",
        endTime: "",
      },
      outlayCount: {},
      repairList: [],
      oilList: [],
      otherList: [],
      activeName: "maintain",
      tableData: [],
      typeList: [],
    }
  },
  mounted() {
    this.getExpenseRecordList()
    this.getOutlayOtherPayName()
  },
  methods: {
    // 获取其他支出项
    async getOutlayOtherPayName() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/outlayOtherPayName"
      )
      if (res.code == 1) {
        _this.typeList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    // 匹配支出项名称
    matchOtherPayName(code) {
      let _this = this
      let data = _this.typeList.filter((item) => {
        return item.code == code
      })
      if (data.length > 0) {
        return data[0].value
      }
    },
    // 文件导出
    exportFile() {
      let _this = this
      let url =
        "/api/outlay/manage/record/export?vinList=" +
        _this.vinList +
        "&startTime=" +
        _this.queryForm.startTime +
        "&endTime=" +
        _this.queryForm.endTime
      window.location.href = url
    },
    checkImg(url) {
      this.deiverVisible = true
      this.imgUrl = ""
      this.imgUrlList = []
      this.imgUrl = url
      this.imgUrlList.push(url)
    },
    // 查询车辆费用记录
    async getExpenseRecordList() {
      let _this = this
      let obj = {
        startTime: _this.queryForm.startTime,
        endTime: _this.queryForm.endTime,
        vinList: _this.vinList,
      }
      let { data: res } = await _this.$axios.get("/api/outlay/manage/record", {
        params: obj,
      })
      if (res.code == 1) {
        console.log(res)
        _this.outlayCount = res.data.outlayCount
        _this.repairList = res.data.repairList
        _this.oilList = res.data.oilList
        _this.otherList = res.data.otherList
      } else {
        _this.$message.warning(res.msg)
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.getExpenseRecordList()
    },
    goback() {
      this.$emit("goback")
    },
    changeStart(val) {
      this.queryForm.startTime = val
    },
    changeEnd(val) {
      this.queryForm.endTime = val
    },
    query() {
      this.getExpenseRecordList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getExpenseRecordList()
    },
  },
}
</script>

<style lang="scss" scoped>
.son-wrap {
  display: flex;
  flex-direction: row;
  height: calc(100% - 42px);
}
.son-wrap .el-container {
  background-color: #fff;
  height: 100%;
}
.son-box {
  padding: 20px;
}
.wrapBox {
  width: 100%;
  height: calc(100% - 20px);
}
.top {
  margin-bottom: 10px;
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border: 1px solid #ebeef5;
}
.expenseItem {
  padding: 30px 20px;
  border: 2px solid #ebeef5;
  border-radius: 6px;
  margin-bottom: 20px !important;
}
/deep/ .el-table td,
/deep/ .el-table--mini th {
  padding: 6px 0px;
}
/deep/ .el-table--border,
.el-table--group {
  border: none;
}
/deep/ .el-table--border::after,
/deep/ .el-table--group::after {
  height: fit-content;
}
.expenseImg {
  width: 17px;
  height: 14px;
  cursor: pointer;
}
</style>
